import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthResponseModel } from './auth-response.model';
import { HeadersService } from '../header.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly authTokenKey = 'AUTH-TOKEN';
  private readonly isLoggedInBS = new BehaviorSubject(false);
  public readonly isLoggedIn$: Observable<boolean> = this.isLoggedInBS.asObservable();
  public constructor(private readonly http: HttpClient, private headersService: HeadersService) {
    this.headersService.includeObject({ fileName: 'auth.service.ts', url: `${environment.apiUrl}/login` });
    this.headersService.includeObject({ fileName: 'auth.service.ts', url: `${environment.apiUrl}/change-password` });

    const authToken = window.localStorage.getItem(this.authTokenKey);
    this.isLoggedInBS.next(!!authToken);
  }

  public readonly login = (login: string, password: string): Observable<boolean> => {
    return this.http.post<AuthResponseModel>(`${environment.apiUrl}/login`, { login, password }).pipe(
      tap((response) => {
        window.localStorage.setItem(this.authTokenKey, response.token);
        window.localStorage.setItem('companyId', response.companyId.toString());
        this.isLoggedInBS.next(true);
      }),
      map((response) => !!response.token),
      catchError((error) => {
        /* TODO: handle this error to fire an alert or toast to inform the user the login failed. */
        return of(false);
      })
    );
  };

  public readonly changePassword = (password: string): Observable<boolean> => {
    var headers = new HttpHeaders().set('Authorization', 'Token ' + localStorage.getItem(this.authTokenKey));
    var options = {
      headers: headers
    };

    return this.http.post<any>(`${environment.apiUrl}/change-password`, { password }, options);
  };

  public readonly getAuthToken1 = (): string | null => {
    const token = window.localStorage.getItem(this.authTokenKey);
    return token ? `Bearer ${token}` : null;
  };
}
